import React from "react";
import { useRouteError } from "react-router-dom";
import { Button } from "@mantine/core";
import { useNavigate } from "react-router-dom";

export default function ErrorPage() {
  const navigate = useNavigate();
  const error: any = useRouteError();
  console.error(error);

  const goHome = () => {
    navigate("/");
  };

  return (
    <div id="error-page">
      {error ? (
        <div>
          <h1>Oops!</h1>
          <p>Sorry, an unexpected error has occurred.</p>
          <p>
            <i>{error.statusText || error.message}</i>
          </p>
        </div>
      ) : (
        <div>
          <h1>404</h1>
          <p>Sorry, the page you are looking for does not exist.</p>
          <Button onClick={goHome}>Back Home</Button>
        </div>
      )}
    </div>
  );
}
